// extracted by mini-css-extract-plugin
module.exports = {"customSlider":"Paint_customSlider__J7CiD","customPopover":"Paint_customPopover__lvGRC"};